







































































import { mapActions, mapGetters } from 'vuex';
import { updateStateFeatureFlag } from '@/api/CopyStake/FeatureFlags';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { ECopyStakeFeatureFlag } from '@/store/modules/feature-flags/FeatureFlagNames';
import {
  EJackpotCampaignStatusType,
  IJackpotCampaign,
  IJackpotCampaignDetails
} from '@/api/schema';
import { updateCampaignStatus } from '@/api/CopyStake/GamificationCenter/Jackpot';

export default {
  name: 'CopyStakeGamificationCenterJackpotTab',
  components: {
    CopyStakeGamificationCenterJackpotCampaignsTable: (): any =>
      import(
        '@/views/CopyStake/CopyStakeGamificationCenter/Jackpot/CampaignsTable/CopyStakeJackpotCampaignsTable.vue'
      ),
    CopyStakeJackpotCampaignDialog: (): any =>
      import(
        '@/views/CopyStake/CopyStakeGamificationCenter/Jackpot/ManageCampaignDialog/CopyStakeJackpotCampaignDialog.vue'
      ),
    ConfirmationDialog: (): any =>
      import('@/components/ConfirmationDialog.vue')
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data(): any {
    return {
      needToRefetchTableData: false,
      isJackpotFeatureFlagEnabledProcessing: false,
      dialogs: {
        confirmationDialog: false,
        copyStakeJackpotCampaignDialog: false,
        isLoading: false,
        campaignId: null,
        isCopy: false,
        confirmationData: null
      }
    };
  },
  computed: {
    ...mapGetters('FeatureFlags', [
      'isFeaturesLoading',
      'isEnabledFeatureFlag',
      'featureFlagIdByName'
    ]),
    jackpotFeatureFlagId(): number | null {
      return this.featureFlagIdByName(
        ECopyStakeFeatureFlag.GAMIFICATION_CENTER_JACKPOT
      );
    },
    isJackpotFeatureFlagEnabled(): boolean {
      return this.isEnabledFeatureFlag(
        ECopyStakeFeatureFlag.GAMIFICATION_CENTER_JACKPOT
      );
    }
  },
  methods: {
    ...mapActions('FeatureFlags', ['getOperatorCopyStakeFeatureFlags']),
    async handleClickIsJackpotFeatureFlagEnabledSwitch(): Promise<void> {
      if (
        this.isJackpotFeatureFlagEnabledProcessing ||
        !this.jackpotFeatureFlagId
      ) {
        return;
      }

      this.isJackpotFeatureFlagEnabledProcessing = true;

      if (this.isJackpotFeatureFlagEnabled) {
        this.openDeactivateJackpotFeatureFlagConfirmationDialog();
      } else {
        await this.changeJackpotFeatureFlagState();
      }
    },
    async changeJackpotFeatureFlagState(): Promise<void> {
      try {
        this.dialogs.isLoading = true;
        this.isJackpotFeatureFlagEnabledProcessing = true;

        await updateStateFeatureFlag(
          this.jackpotFeatureFlagId,
          !this.isJackpotFeatureFlagEnabled
        );

        this.handlerCloseConfirmationDialog();

        await this.getOperatorCopyStakeFeatureFlags();
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.isJackpotFeatureFlagEnabledProcessing = false;
        this.dialogs.isLoading = false;
      }
    },
    async changeStatusJackpotCampaign(
      campaign: IJackpotCampaign,
      newStatus: EJackpotCampaignStatusType,
      isRestore: boolean = false
    ): Promise<void> {
      const statusesConfig = {
        [EJackpotCampaignStatusType.ACTIVE]: {
          toastText: `Campaign "${campaign.name}" was successfully activated`
        },
        [EJackpotCampaignStatusType.PENDING]: {
          toastText: `Campaign "${campaign.name}" was successfully ${
            isRestore ? 'restored' : 'deactivated'
          }`
        },
        [EJackpotCampaignStatusType.DELETED]: {
          toastText: `Campaign "${campaign.name}" was successfully removed`
        }
      };

      try {
        this.dialogs.isLoading = true;

        await updateCampaignStatus(campaign.id, newStatus);

        this.handlerCloseConfirmationDialog();
        this.$toast.success(statusesConfig[newStatus].toastText);

        this.updateCampaignsDataTable();
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.dialogs.isLoading = false;
      }
    },
    openCopyStakeJackpotCampaignDialog(
      campaign: IJackpotCampaignDetails | null,
      isCopy: boolean = false
    ): void {
      this.dialogs.campaignId = campaign?.id || null;
      this.dialogs.copyStakeJackpotCampaignDialog = true;
      this.dialogs.isCopy = isCopy;
    },
    openDeactivateJackpotFeatureFlagConfirmationDialog(): void {
      this.dialogs.confirmationData = {
        disclaimer: `Are you sure you want to disable this feature?`,
        header: 'Confirm Feature Deactivation',
        okText: 'Deactivate',
        handler: () => this.changeJackpotFeatureFlagState()
      };
      this.dialogs.confirmationDialog = true;
    },
    openActivateCampaignConfirmationDialog(
      campaign: IJackpotCampaignDetails
    ): void {
      this.dialogs.confirmationData = {
        disclaimer: `Are you sure you want to activate this campaign?`,
        header: 'Activate Campaign',
        okText: 'Activate',
        handler: () =>
          this.changeStatusJackpotCampaign(
            campaign,
            EJackpotCampaignStatusType.ACTIVE
          )
      };
      this.dialogs.confirmationDialog = true;
    },
    openDeactivateCampaignConfirmationDialog(
      campaign: IJackpotCampaignDetails
    ): void {
      this.dialogs.confirmationData = {
        disclaimer: `Are you sure you want to deactivate this campaign?`,
        header: 'Deactivate Campaign',
        okText: 'Deactivate',
        handler: () =>
          this.changeStatusJackpotCampaign(
            campaign,
            EJackpotCampaignStatusType.PENDING
          )
      };
      this.dialogs.confirmationDialog = true;
    },
    openRemoveCampaignConfirmationDialog(
      campaign: IJackpotCampaignDetails
    ): void {
      this.dialogs.confirmationData = {
        disclaimer: `Are you sure you want to remove this campaign?`,
        header: 'Remove Campaign',
        okText: 'Remove',
        handler: () =>
          this.changeStatusJackpotCampaign(
            campaign,
            EJackpotCampaignStatusType.DELETED
          )
      };
      this.dialogs.confirmationDialog = true;
    },
    openRestoreCampaignConfirmationDialog(
      campaign: IJackpotCampaignDetails
    ): void {
      this.dialogs.confirmationData = {
        disclaimer: `Are you sure you want to restore this campaign?`,
        header: 'Restore Campaign',
        okText: 'Restore',
        handler: () =>
          this.changeStatusJackpotCampaign(
            campaign,
            EJackpotCampaignStatusType.PENDING,
            true
          )
      };
      this.dialogs.confirmationDialog = true;
    },
    updateCampaignsDataTable(): void {
      this.needToRefetchTableData = true;
    },
    handlerClickAddCampaignBtn(): void {
      this.openCopyStakeJackpotCampaignDialog();
    },
    handlerSubmitCopyStakeJackpotCampaignDialog(): void {
      this.updateCampaignsDataTable();
    },
    handlerCloseCopyStakeJackpotCampaignDialog(): void {
      this.dialogs.copyStakeJackpotCampaignDialog = false;
      this.dialogs.campaignId = null;
      this.dialogs.isCopy = false;
    },
    handlerCloseConfirmationDialog(): void {
      this.isJackpotFeatureFlagEnabledProcessing = false;

      this.dialogs.confirmationDialog = false;
      this.dialogs.confirmationData = null;
    },
    handlerEditCampaignEvent(campaign: IJackpotCampaign): void {
      this.openCopyStakeJackpotCampaignDialog(campaign);
    },
    handlerCopyCampaignEvent(campaign: IJackpotCampaign): void {
      this.openCopyStakeJackpotCampaignDialog(campaign, true);
    },
    handlerActivateCampaignEvent(campaign: IJackpotCampaign): void {
      this.openActivateCampaignConfirmationDialog(campaign);
    },
    handlerDeactivateCampaignEvent(campaign: IJackpotCampaign): void {
      this.openDeactivateCampaignConfirmationDialog(campaign);
    },
    handlerRemoveCampaignEvent(campaign: IJackpotCampaign): void {
      this.openRemoveCampaignConfirmationDialog(campaign);
    },
    handlerRestoreCampaignEvent(campaign: IJackpotCampaign): void {
      this.openRestoreCampaignConfirmationDialog(campaign);
    }
  }
};
